// Copyright (c) 2016 Deere & Company

import KeyValueCollection, {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../../action-list';

const setInstalledBy = (state, action) =>
    KeyValueCollection.update(state, {
        $set: action.installedBy
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_TRACK_INSTALLED_BY_COLLECTION]: setInstalledBy
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/track/reducers/installed-by.js